import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, Teleport as _Teleport } from "vue"
import _imports_0 from '../../assets/icons/add.png'


const _hoisted_1 = { class: "main-container mt-8 content-start items-start" }
const _hoisted_2 = { class: "flex col-start-1 col-end-13 justify-between items-center-w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "ac-large-title" }, "Ürün Kategorileri", -1)
const _hoisted_4 = { class: "action-row col-start-1 col-end-13 flex items-center justify-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4 filter-white",
  width: "20",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "alt-table col-start-1 col-end-13 w-full mt-5"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Renk"),
    /*#__PURE__*/_createElementVNode("th", null, "Kategori"),
    /*#__PURE__*/_createElementVNode("th", null, "İşlemler")
  ])
], -1)
const _hoisted_8 = { class: "text-overflow w-24" }
const _hoisted_9 = { class: "text-overflow" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

import { ref, onBeforeMount, onBeforeUnmount } from "vue"
import { useGetDocs, postData, updateMeta, deleteData } from "../../mixins/modularFirebaseOperations"
import { modalClosed } from "../../mixins/visualFormatters"
import { propagateMetaToItems } from "@/composables/inventoryHelpers"
import AcMediumModal from "../reusable/teleports/acMediumModal.vue"
import InventoryMetaForm from "../reusable/form-widgets/inventoryMetaForm.vue"
import resetBackground from "@/mixins/resetBackground"
import removeBackground from "@/mixins/removeBackground"
import type { AcProductCategory } from "../../types/inventory"

const COLLECTION = "inventory/categories/list"


export default /*#__PURE__*/_defineComponent({
  __name: 'inventoryCategories',
  setup(__props) {


const isAddingMeta = ref<boolean>(false)
const editedMeta = ref<AcProductCategory | undefined>(undefined)
const { docs, isLoadingDocs } = useGetDocs<AcProductCategory>(COLLECTION)

const handleAddMeta = async function(meta: AcProductCategory) {
    const docRef = await postData(meta, COLLECTION)
    docs.value.push({ ...meta, id: docRef as string })
    isAddingMeta.value = false
    modalClosed()
}

const handleDelete = async function(metaId: string) {
    if (!confirm("Bu kategoriyi silmek istediğinize emin misiniz?")) return
    await deleteData(COLLECTION, metaId)
    docs.value = docs.value.filter((meta) => meta.id !== metaId)
}

const handleUpdatedData = async function(meta: AcProductCategory) {
    await updateMeta(COLLECTION, meta.id!, meta)
    // Refresh the embedded category snapshot on every item that references it.
    await propagateMetaToItems("productCategory", meta)
    const updatedMeta = docs.value.find((existingMeta) => existingMeta.id === meta.id)
    if (updatedMeta) {
        updatedMeta.name = meta.name
        updatedMeta.color = meta.color
    }
    editedMeta.value = undefined
    modalClosed()
}

onBeforeMount(() => {
  removeBackground.methods.removeBackground()
})

onBeforeUnmount(() => {
  resetBackground.methods.resetBackground()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddingMeta.value = true)),
          class: "ac-add-button"
        }, [
          _hoisted_5,
          _createTextVNode(" Yeni Kategori Ekle ")
        ])
      ])
    ]),
    (!_unref(isLoadingDocs))
      ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
          _hoisted_7,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(docs), (meta) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "hover:bg-gray-200 relative cursor-pointer",
              key: meta.id
            }, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", {
                  class: "w-6 h-6 rounded-full",
                  style: _normalizeStyle({ backgroundColor: meta.color })
                }, null, 4)
              ]),
              _createElementVNode("td", _hoisted_9, _toDisplayString(meta.name), 1),
              _createElementVNode("td", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: "table-button",
                  onClick: ($event: any) => (handleDelete(meta.id!))
                }, " Sil ", 8, _hoisted_11),
                _createElementVNode("button", {
                  type: "button",
                  class: "table-button",
                  onClick: ($event: any) => (editedMeta.value = meta)
                }, " Düzenle ", 8, _hoisted_12)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingMeta.value || editedMeta.value)
            ? (_openBlock(), _createBlock(AcMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                onModalClosed: _cache[3] || (_cache[3] = ($event: any) => {isAddingMeta.value = false; editedMeta.value = undefined}),
                height: "fit-content",
                width: "40vw",
                title: "Kategori"
              }, {
                default: _withCtx(() => [
                  _createVNode(InventoryMetaForm, {
                    metaTitle: "Kategori",
                    hasColor: true,
                    existingMeta: editedMeta.value,
                    onMetaAdded: _cache[1] || (_cache[1] = ($event: any) => (handleAddMeta($event))),
                    onMetaUpdated: _cache[2] || (_cache[2] = ($event: any) => (handleUpdatedData($event)))
                  }, null, 8, ["existingMeta"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})